const config = {
  start: {
    img: "start.png",
    header: "Kuinka hyvin tunnet Festivon? Testaa tietosi!",
    text: "Osallistu monivalintavisaan kotimaisista kylmälaitteista ja saat tietää millainen Festivo-tietäjä olet!",
    link: {
      text: "",
      url: "",
    },
  },
  end: {
    img: "end.png",
    text: "Kiitos, että testasit Festivo-tietosi!",
  },
  questions: [
    {
      question:
        "Mikä on Festivon kylmiön, pakastimen ja viinikaapin kotimaisuusaste?",
      explanation: {
        text: "Jokainen Festivo valmistetaan suomalaisena käsityönä ja kaikkien kodin kylmälaitteiden kohdalla kotimaisuusaste on 80 %. {link}!",
        link: {
          text: "Lue mistä Festivon eri osat tulevat",
          url: "https://www.festivo.fi/blogi/luotamme-kotimaiseen-osaamiseen/",
        },
      },
      type: "select-one",
      answers: ["c"],
      img: "1.png",
      options: [
        {
          text: "55 %.",
          value: "a",
        },
        {
          text: "60 %.",
          value: "b",
        },
        {
          text: "80 %.",
          value: "c",
        },
      ],
    },
    {
      question:
        "Festivot valmistava Suomen Kotikylmiö Oy on markkinoiden ainoa kotimainen kodin kylmälaitevalmistaja.",
      explanation: {
        text: "Kyllä! Kodinkonemarkkinoilta löytyy lukuisia eri valmistajia, mutta jääkaappien ja pakastimien osalta Festivo on ainoa kotimainen valmistaja. Suomen Kotikylmiö Oy:n Festivo-tuotemerkin kylmiöt, pakastimet ja viinikaapit valmistetaan käsityönä Hollolassa sijaitsevalla tehtaalla osoitteessa Ravitie 3.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-one",
      answers: ["a"],
      img: "2.png",
      options: [
        {
          text: "Kyllä.",
          value: "a",
        },
        {
          text: "Ei.",
          value: "b",
        },
      ],
    },
    {
      question:
        "Citycold kylmäpakkanen on vetolaatikkomallinen kylmälaite, jossa on samassa laitteessa jääkaappilämpötila ja pakkanen. Miten voit sijoittaa sen keittiöön? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Citycold on keittiökalusteisiin mitoitettu, työtason alle sijoitettava vetolaatikosto. Sen voi halutessaan integroida. Laitteen saa myös vapaasti sijoitettavana, jolloin laite on saatavilla valkoisilla, mustilla tai RST etulevyillä. {link}!",
        link: {
          text: "Tutustu tarkemmin Citycoldiin",
          url: "https://www.festivo.fi/kodin-kylmalaitteet/citycold/",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "d"],
      img: "3.png",
      options: [
        {
          text: "Keittiötason alle tai saarekkeeseen",
          value: "a",
        },
        {
          text: "Vapaasti seisovaksi",
          value: "b",
        },
        {
          text: "Yläkaapistoon",
          value: "c",
        },
        {
          text: "Integroituna keittiökalusteisiin",
          value: "d",
        },
      ],
    },
    {
      question: "Onko kylmiössä aina pakastin?",
      explanation: {
        text: "Kylmiö ei sisällä pakastinlämpötilaa vaan pakkanen tulee ostaa kaksiovisissa kylmälaitteissa erikseen.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-one",
      answers: ["b"],
      img: "4.png",
      options: [
        {
          text: "Kyllä.",
          value: "a",
        },
        {
          text: "Ei.",
          value: "b",
        },
      ],
    },
    {
      question:
        "Missä väreissä Festivon kylmiö, pakastin ja viinikaappi on mahdollista saada? Valitse kolme oikeaa vastausta.",
      explanation: {
        text: "Rungon väriksi vaihtoehtoina ovat valkoinen, musta ja harmaa. Ovien väreissä vaihtoehtoina ovat valkoinen, musta ja RST eli ruostumaton teräs.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-multi",
      answers: ["a", "c", "d"],
      img: "5.png",
      options: [
        {
          text: "Valkoinen.",
          value: "a",
        },
        {
          text: "Punainen.",
          value: "b",
        },
        {
          text: "Musta.",
          value: "c",
        },
        {
          text: "Harmaa / RST.",
          value: "d",
        },
      ],
    },
    {
      question:
        "Festivon mustat kylmälaitteet ovat nykyisin kaikki kiiltoasteeltaan himmeämpiä eli ns. mattamustia.",
      explanation: {
        text: "Totta! Huhtikuussa 2023 Festivon mustan kylmälaitevärin korvasi kiiltoasteeltaan himmeämpi musta ja aiempi musta poistui valikoimasta. Kylmiöihin, pakastimeen sekä viinikaappeihin on kuitenkin valittavissa eri väriset rungot ja ovet.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-one",
      answers: ["a"],
      img: "6.png",
      options: [
        {
          text: "Totta",
          value: "a",
        },
        {
          text: "Tarua",
          value: "b",
        },
      ],
    },
    {
      question:
        "Festivon 75 cm leveä yksiovinen kylmiöpakastin uudistui hiljattain. Mitä laitteissa muuttui? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Kylmiöpakastimet 75 CF0 ja 75 CFF ovat yksiovisia kompaktin kokoisia kylmiöpakastimia, jotka sopivat erinomaisesti pienempiinkin keittiöihin. {link}!",
        link: {
          text: "75 cm leveä kylmiöpakastin uudistui hiljattain, lue lisää",
          url: "https://www.festivo.fi/ajankohtaista/yksiovinen-kylmiopakastin-uudistus/",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "d"],
      img: "7.png",
      options: [
        {
          text: "Pakastin on nyt automaattisulatteinen.",
          value: "a",
        },
        {
          text: "Saat valita, onko laitteessa kaksi pakastinvetolaatikkoa vai pakastin ja NOLLA-tila.",
          value: "b",
        },
        {
          text: "Vetimet vaihtuivat pyöreiksi.",
          value: "c",
        },
        {
          text: "KYLMÄ-vetolaatikko kylmiön puolelle.",
          value: "d",
        },
      ],
    },
    {
      question:
        "Missä leveysmitoissa Festivon kylmiö on mahdollista saada? Valitse kaikki mitat:",
      explanation: {
        text: "Festivon kylmiö on saatavissa leveysmitoissa 55 cm ja 75 cm sekä kaksiovissa kylmiöissä 90 cm, 100 cm ja 120 cm. {link}!",
        link: {
          text: "Tutustu kaikkiin kylmiöihin",
          url: "https://www.festivo.fi/kodin-kylmalaitteet/kylmio/",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "d", "e", "f"],
      img: "8.png",
      options: [
        {
          text: "90 cm",
          value: "a",
        },
        {
          text: "75 cm",
          value: "b",
        },
        {
          text: "65 cm",
          value: "c",
        },
        {
          text: "100 cm",
          value: "d",
        },
        {
          text: "55 cm",
          value: "e",
        },
        {
          text: "120 cm",
          value: "f",
        },
        {
          text: "50 cm",
          value: "g",
        },
      ],
    },
    {
      question:
        "Missä leveysmitoissa Festivon kylmiöpakastin on mahdollista saada? Valitse kaikki mitat:",
      explanation: {
        text: "Festivon kylmiöpakastin on saatavilla leveysmitoissa 100 cm, 120 cm ja 75 cm. Kylmiöpakastin koostuu 45 FM pakastimesta ja joko 75 CM tai 55 CM kylmiöstä. Lisäksi mallistossa on kaksi yksiovista kylmiöpakastinta: 75 CFF ja 75 CF0. {link}!",
        link: {
          text: "Tutustu kaikkiin kylmiöpakastimiin",
          url: "https://www.festivo.fi/kodin-kylmalaitteet/kylmiopakastin/",
        },
      },
      type: "select-multi",
      answers: ["b", "c", "d"],
      img: "9.png",
      options: [
        {
          text: "130 cm",
          value: "a",
        },
        {
          text: "100 cm",
          value: "b",
        },
        {
          text: "120 cm",
          value: "c",
        },
        {
          text: "75 cm",
          value: "d",
        },
      ],
    },
    {
      question:
        "Mitä Festivon kylmälaitteiden modulaarisuus tarkoittaa? Valitse oikeat vaihtoedot:",
      explanation: {
        text: "Väittämistä kaikki on totta! Kylmälaitemalliston modulaarisuus mahdollistaa uudenlaisen yhdistelyn kylmiön, pakastimen ja viinikaapin välillä sekä sisätilojen muokkauksen!",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "c", "d"],
      img: "10.png",
      options: [
        {
          text: "Saat valita kylmiöön ja pakastimeen eri määrän vetolaatikoita.",
          value: "a",
        },
        {
          text: "Kylmälaitteet rakentuvat erillisistä moduuleista (kylmiö, pakastin, viinikaappi), joita voi yhdistää toisiinsa.",
          value: "b",
        },
        {
          text: "Kylmiön ja pakastimen voi sijoittaa erilleen toisistaan.",
          value: "c",
        },
        {
          text: "Kätisyyden saa valita tilauksen yhteydessä.",
          value: "d",
        },
      ],
    },
    {
      question:
        "Mitä voit muuttaa Festivon kylmälaitteissa, kun laite on jo keittiössä? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Väittämistä kaikki paitsi rungon väri on oikein! Kätisyys ja laitteiden keskinäinen järjestys on mahdollista muuttaa jälkikäteen esimerkiksi keittiöremontin yhteydessä.{break}{break}Myös vetolaatikoita on mahdollista asentaa laitteisiin jälkikäteen, mutta helpoimmin asia sujuu jo tehtaalla ennen toimitusta.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "c", "d"],
      img: "11.png",
      options: [
        {
          text: "Laitteiden keskinäisen järjestyksen.",
          value: "a",
        },
        {
          text: "Laitteen/laitteiden kätisyyden.",
          value: "b",
        },
        {
          text: "Vetolaatikoiden määrän.",
          value: "c",
        },
        {
          text: "Lasihyllyjen järjestyksen.",
          value: "d",
        },
        {
          text: "Rungon värin.",
          value: "e",
        },
      ],
    },
    {
      question:
        "Mitkä ovat kylmiön, pakastimen ja viinikaapin vakiovarusteet? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Kylmiössä on vakiona yksi HEVI-vetolaatikko ja pakastimessa yksi NOLLA-vetolaatikko, 45 VL viinikaappiin kuuluu vakiona puinen varustekappa. Kylmiöpakastimissa yhtenäinen kalustesokkeli ja runkojen liitossarja sisältyvät toimitukseen.{break}{break}Muut ovat valittavana lisävarusteena. Kylmiössä vetolaatikoita voi olla maksimissaan kolme, joista yksi voi sijaita kylmiön jääkaappilämpötilassa (KYLMÄ-vetolaatikko). Pakastimessa voi olla maksimissaan kaksi NOLLA-vetolaatikkoa.",
        link: {
          text: "",
          url: "",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "c", "d"],
      img: "12.png",
      options: [
        {
          text: "Puinen varustekappa 45 VL viinikaappiin.",
          value: "a",
        },
        {
          text: "HEVI-vetolaatikko kylmiöön.",
          value: "b",
        },
        {
          text: "NOLLA-vetolaatikko pakastimeen.",
          value: "c",
        },
        {
          text: "100 CFM ja 120 CFM -kylmiöpakastimissa yhtenäinen kalustesokkeli ja runkojen liitossarja.",
          value: "d",
        },
        {
          text: "KYLMÄ-vetolaatikko kylmiöön.",
          value: "e",
        },
        {
          text: "KAPPA-juuressäilytin.",
          value: "f",
        },
      ],
    },
    {
      question:
        "Miten Festivon kylmiöpakastin eroaa perinteisestä jääkaappipakastimesta? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Eroja löytyy muun muassa kylmätekniikasta, mitoituksesta ja säilytyskapasiteetista, elintarvikkeiden säilyvyydestä (4 eri lämpötila-aluetta) sekä laitteiden muunneltavuudesta. Myös Festivon huollettavuus on omaa luokkaansa. {link}.",
        link: {
          text: "Voit lukea eroista lisää tästä",
          url: "https://www.festivo.fi/blogi/kylmiopakastin-vs-jaakaappipakastin-tekniikassa-suurin-ero/",
        },
      },
      type: "select-multi",
      answers: ["a", "b", "c", "d", "e"],
      img: "13.png",
      options: [
        {
          text: "Festivossa jäähdytys on tehokkaampi, tasaisempi ja nopeampi, koska kylmätekniikkana on lamellihöyrystin.",
          value: "a",
        },
        {
          text: "Kylmiöpakastimessa on neljä eri lämpötila-aluetta.",
          value: "b",
        },
        {
          text: "Suurempi säilytyskapasiteetti elintarvikkeille.",
          value: "c",
        },
        {
          text: "Poikkeava mitoitus ja muokkausmahdollisuudet.",
          value: "d",
        },
        {
          text: "Festivot ovat huollettavissa.",
          value: "e",
        },
        {
          text: "Värivaihtoehdot ovat muusta tarjonnasta poikkeavat.",
          value: "f",
        },
      ],
    },
    {
      question:
        "Mitä ottaa huomioon, kun teet asiakkaalle Festivo-tilausta? Valitse oikeat vaihtoehdot:",
      explanation: {
        text: "Kohdista kaikki muu paitsi B. tulee ottaa huomioon tilausta tehdessä.{break}{break}{link}",
        link: {
          text: "Tarkista sivuiltamme muistilista Festivon tilaukseen.",
          url: "https://www.festivo.fi/blogi/festivon-tilaajan-muistilista/",
        },
      },
      type: "select-multi",
      answers: ["a", "c", "d", "e"],
      img: "14.png",
      options: [
        {
          text: "Tarkoitetaanko kylmiöllä vain kylmiötä vai kylmiöpakastinta.",
          value: "a",
        },
        {
          text: "Kuinka monta litraa maitoa kylmiössä aiotaan säilyttää.",
          value: "b",
        },
        {
          text: "Halutaanko laitteen runkoon ja oviin sama väri.",
          value: "c",
        },
        {
          text: "Jokaisen laitteen haluttu kätisyys.",
          value: "d",
        },
        {
          text: "Halutaanko lisävarusteita, kuten lisää HEVI-laatikoita.",
          value: "e",
        },
      ],
    },
  ],
  results: [
    {
      pointRange: [0, 1, 2, 3],
      title: "Et taida vielä erottaa kylmiötä kynttilänjalasta 😉",
      text: "Ei se mitään, voit käydä tutustumassa kotimaisiin kylmiöihin, pakastimeen ja viinikaappeihin {link}! Tule sen jälkeen kokeilemaan testiä uudelleen!",
      link: {
        text: "sivuillamme",
        url: "https://www.festivo.fi/",
      },
    },
    {
      pointRange: [4, 5, 6, 7],
      title: "Et taida vielä tietää kaikkea Festivon mahtavuudesta",
      text: "Tiedät jo pääpiirteitä Festivosta, mutta kaipaat vielä harjoitusta. Käy tutustumassa kylmiöihin, pakastimeen ja viinikaappeihin {link}!",
      link: {
        text: "sivuillamme",
        url: "https://www.festivo.fi/",
      },
    },
    {
      pointRange: [8, 9, 10, 11],
      title:
        "Hienoa, tiedät jo paljon Festivosta, vielä on kuitenkin hieman petrattavaa",
      text: "Läheltä liippasi! Käy vielä tutustumassa tarkemmin {link} ja nappaa loputkin Festivoiden mahtavuudet haltuun!",
      link: {
        text: "kotimaisiin kylmiöihin, pakastimeen ja viinikaappeihin",
        url: "https://www.festivo.fi/",
      },
    },
    {
      pointRange: [12, 13, 14],
      title:
        "WOW! Olet tainnut käydä Hollolassa tehdaskierroksella tai sitten olet Festivon suuri fani. Mahtavaa!",
      text: "Festivo-tietosi on hienosti hallussa, mahtavaa! Muista vierailla {link}, niin pääset tyydyttämään tiedonjanoasi jatkossakin uusistakin käänteistämme!",
      link: {
        text: "sivuillamme",
        url: "https://www.festivo.fi/",
      },
    },
  ],
};

export default config;
